<div class="ld-panel" *ngIf="row">
  <section class="ld-card">
    <div class="ld-card__header">
      <span class="ld-card__title"><mat-icon>account_balance</mat-icon> Préstamo {{ row.numero }}</span>
      <app-status-pill [label]="durationLabel" [variant]="durationVariant"></app-status-pill>
    </div>

    <div class="ld-progress">
      <div class="ld-progress__bar">
        <div class="ld-progress__fill" [style.width.%]="row.percent"></div>
      </div>
      <div class="ld-progress__legend">
        <span>Amortizado <strong>{{ row.amortizado | number:'1.2-2' }} €</strong></span>
        <span>Pendiente <strong>{{ row.importePendiente | number:'1.2-2' }} €</strong></span>
        <span>Inicial <strong>{{ row.importeInicial | number:'1.2-2' }} €</strong></span>
      </div>
    </div>

    <div class="ld-kpis">
      <div class="ld-kpi">
        <span class="ld-kpi__label">Tipo de interés</span>
        <span class="ld-kpi__value">{{ hasValue(row.tipoInteres) ? (row.tipoInteres | number:'1.2-2') + ' %' : '—' }}</span>
      </div>
      <div class="ld-kpi">
        <span class="ld-kpi__label">Plazo</span>
        <span class="ld-kpi__value">{{ hasValue(row.plazo) ? row.plazo + ' meses' : '—' }}</span>
      </div>
      <div class="ld-kpi">
        <span class="ld-kpi__label">Carencia</span>
        <span class="ld-kpi__value">{{ hasValue(row.carencia) ? row.carencia + ' meses' : '—' }}</span>
      </div>
      <div class="ld-kpi">
        <span class="ld-kpi__label">Liquidación</span>
        <span class="ld-kpi__value">{{ settlementLabel }}</span>
      </div>
      <div class="ld-kpi">
        <span class="ld-kpi__label">Comisión apertura</span>
        <span class="ld-kpi__value">{{ (row.comisionApertura || 0) | number:'1.2-2' }} €</span>
      </div>
      <div class="ld-kpi">
        <span class="ld-kpi__label">Vencimiento</span>
        <span class="ld-kpi__value">{{ row.fechaFinalizacion ? (row.fechaFinalizacion | date:'dd/MM/yyyy') : '—' }}</span>
      </div>
    </div>

    <div class="ld-kpis ld-kpis--compact" *ngIf="!loading && !error">
      <div class="ld-kpi ld-kpi--accent">
        <span class="ld-kpi__label">Capital pagado {{ year }}</span>
        <span class="ld-kpi__value">{{ paidCapital | number:'1.2-2' }} €</span>
      </div>
      <div class="ld-kpi">
        <span class="ld-kpi__label">Intereses {{ year }}</span>
        <span class="ld-kpi__value">{{ paidInterest | number:'1.2-2' }} €</span>
      </div>
      <div class="ld-kpi">
        <span class="ld-kpi__label">Gastos bancarios {{ year }}</span>
        <span class="ld-kpi__value">{{ paidBankFees | number:'1.2-2' }} €</span>
      </div>
    </div>

    <div class="ld-lines">
      <div class="ld-line">
        <span class="ld-line__label">Cuenta a largo plazo</span>
        <span class="ld-line__value">{{ row.accountingModelsLargoPlazoNumber || '—' }}</span>
      </div>
      <div class="ld-line">
        <span class="ld-line__label">Cuenta a corto plazo</span>
        <span class="ld-line__value">{{ row.accountingModelsCortoPlazoNumber || '—' }}</span>
      </div>
    </div>

    <div class="ld-actions">
      <button mat-stroked-button class="cf-btn cf-btn--primary" (click)="edit.emit()">
        <mat-icon>edit</mat-icon> Editar préstamo
      </button>
    </div>
  </section>

  <section class="ld-card">
    <div class="ld-card__header">
      <span class="ld-card__title"><mat-icon>date_range</mat-icon> Movimientos del ejercicio {{ year }}</span>
    </div>

    <app-loading-state *ngIf="loading" [compact]="true" message="Cargando movimientos…"></app-loading-state>

    <div class="ld-empty ld-empty--error" *ngIf="!loading && error">
      <mat-icon>error</mat-icon>
      <span>No se pudieron cargar los movimientos del préstamo.</span>
      <button mat-stroked-button class="cf-btn" (click)="retry()">
        <mat-icon>refresh</mat-icon> Reintentar
      </button>
    </div>

    <ng-container *ngIf="!loading && !error">
      <div class="ld-block" *ngFor="let block of blocks; trackBy: trackByKind">
        <div class="ld-block__header">
          <span class="ld-block__title"><mat-icon>{{ block.icon }}</mat-icon> {{ block.title }}</span>
          <span class="ld-block__side">
            <span class="ld-block__summary" *ngIf="block.count > 0">
              {{ block.count }} · <strong>{{ block.total | number:'1.2-2' }} €</strong>
            </span>
            <button mat-stroked-button type="button" class="cf-btn cf-btn--primary ld-add" (click)="add(block)">
              <mat-icon>add</mat-icon> Añadir
            </button>
          </span>
        </div>

        <div class="ld-moves" *ngIf="block.lines.length">
          <div class="ld-move" *ngFor="let line of block.lines; trackBy: trackByUid">
            <span class="ld-move__date">{{ line.date | date:'dd/MM/yyyy' }}</span>
            <span class="ld-move__info">
              <span class="ld-move__concept" [title]="line.concept">{{ line.concept }}</span>
              <span class="ld-move__meta" *ngIf="line.meta" [title]="line.meta">{{ line.meta }}</span>
            </span>
            <span class="ld-move__amount">{{ line.amount | number:'1.2-2' }} €</span>
            <span class="ld-move__actions">
              <button type="button" class="ld-icon-btn" (click)="editLine(block, line)" title="Editar" aria-label="Editar movimiento">
                <mat-icon>edit</mat-icon>
              </button>
              <button type="button" class="ld-icon-btn ld-icon-btn--danger" (click)="deleteLine(block, line)" title="Eliminar" aria-label="Eliminar movimiento">
                <mat-icon>delete</mat-icon>
              </button>
            </span>
          </div>
          <button type="button" class="ld-more" *ngIf="block.count > maxLines" (click)="manage(block)">
            Ver los {{ block.count }} movimientos <mat-icon>chevron_right</mat-icon>
          </button>
        </div>

        <div class="ld-block__empty" *ngIf="!block.lines.length">Sin movimientos en el ejercicio</div>
      </div>
    </ng-container>
  </section>
</div>
